import { ChecklistTaskDropdown, ChecklistTaskDropdownSelectedProps, DrilldownMappingItems } from "../types/DataDD/DataDD"
import { SapVersion } from "./Enums"

export const ssoProperties = {
    redirectUri: import.meta.env.VITE_SSO_REDIRECT_URL,
    clientId: import.meta.env.VITE_SSO_CLIENT_ID,
    authority: "https://login.microsoftonline.com/13c728e0-bb0c-4cf7-8e10-5b327279d6d9",
    knownAuthorities: ["https://login.microsoftonline.com/13c728e0-bb0c-4cf7-8e10-5b327279d6d9"],
    scopes: [import.meta.env.VITE_SSO_SCOPE]
}
// OIDC-compliant CIAM policy (migrated from deprecated B2C_1A_CXP_SIGNINSIGNUP_DEMATIC)
const ciamPolicy =
    import.meta.env.VITE_CIAM_POLICY || "B2C_1A_CIAM_SIGNINSIGNUP_DEMATIC";

export const ssoPropertiesCIAM = {
    redirectUri: import.meta.env.VITE_SSO_REDIRECT_URL,
    clientId: import.meta.env.VITE_CIAM_CLIENT_ID,
    authority: `${import.meta.env.VITE_CIAM_Base_Login_URL}/${import.meta.env.VITE_CIAM_TENANT_ID}/${ciamPolicy}`,
    knownAuthorities: [`${import.meta.env.VITE_CIAM_Base_Login_URL}/${import.meta.env.VITE_CIAM_TENANT_ID}`],
    // openid is required for OIDC-compliant CIAM policies; idToken remains the API bearer for external users
    scopes: ["openid"],
}

export const URLs = {
    host: import.meta.env.VITE_API_URL,
    getModels: () => `${URLs.host}/model`,
    getModelsPerDiscipline: (disciplineId) => `${URLs.host}/model/${disciplineId}`,
    getUnitUrl: (projectNumber, disciplineId, sequenceNumber) => `${URLs.host}/unit?projectNumber=${projectNumber}&disciplineId=${disciplineId}&sequenceNumber=${encodeURIComponent(sequenceNumber)}`,
    getAdHocUnitsUrl: (projectNumber) => `${URLs.host}/unit/adhoc?projectNumber=${projectNumber}`,
    postAdHocUnitUrl: () => `${URLs.host}/unit/adhoc`,
    getUnitCheckListUrl: (
        projectNumber,
        disciplineId,
        sequenceNumber,
        unitNumber) => `${URLs.host}/unit-checklist?projectNumber=${projectNumber}&disciplineId=${disciplineId}&sequenceNumber=${encodeURIComponent(sequenceNumber)}&unitNumber=${encodeURIComponent(unitNumber)}`,
    updateUnitCheckListUrl: (unitChecklistUUID) => `${URLs.host}/unit-checklist/${encodeURIComponent(unitChecklistUUID)}`,
    postPullProjectGenerateChecklis: () => `${URLs.host}/queue-job`,
    getAssignmentsUrl: () => `${URLs.host}/assignment`,
    getInspections: (disciplineId) => `${URLs.host}/Inspection?disciplineId=${disciplineId}`,
    addInspectionTask: () => `${URLs.host}/InspectionTask`,
    addInspection: () => `${URLs.host}/Inspection`,
    editDeleteInspectionTask: (inspectionTaskId) => `${URLs.host}/InspectionTask/${inspectionTaskId}`,
    getExtendedProjects: () => `${URLs.host}/Project/extended`,
    getAssignmentUrl: (uuid) => `${URLs.host}/assignment/${encodeURIComponent(uuid)}`,
    putAssignmentsUrl: (uuid) => `${URLs.host}/assignment/${encodeURIComponent(uuid)}`,
    getLinkDisciplineTechCategory: () => `${URLs.host}/Link/discipline-technology-category`,
    getLinkDisciplineIssues: () => `${URLs.host}/Link/discipline-issue`,
    getInspectionTaskLink: (disciplineId) => `${URLs.host}/InspectionTaskLink?disciplineId=${disciplineId}`,
    addInspectionTaskLink: () => `${URLs.host}/InspectionTaskLink`,
    getGroupedInspectionTaskLinks: (inspectionTaskId: number) => `${URLs.host}/InspectionTaskLink?inspectionTaskId=${inspectionTaskId}`,
    editDeleteInspectionTaskLink: (itLinkId: number) => `${URLs.host}/InspectionTaskLink/${itLinkId}`,
    getRootCauses: () => `${URLs.host}/RootCause`,
    getBusinessUnits: () => `${URLs.host}/BusinessUnit`,
    getRegions: () => `${URLs.host}/Region`,
    getInspectionTask: (disciplineId) => `${URLs.host}/InspectionTask?disciplineId=${disciplineId}`,
    getOnHoldCauses: () => `${URLs.host}/onHoldReason`,
    getTechnology: () => `${URLs.host}/Technology`,
    getAccessLevels: () => `${URLs.host}/AccessLevel`,
    postAssignmentsUrl: () => `${URLs.host}/assignment`,
    getAssignmentUsingLoginIdUrl: (loginId) => `${URLs.host}/assignment?loginOrEmail=${encodeURIComponent(loginId)}`,
    getDisciplinesUrl: () => `${URLs.host}/discipline`,
    getDisciplinesPerProjectUrl: (projectNumber) => `${URLs.host}/discipline?projectNumber=${projectNumber}`,
    getProjectsUrl: () => `${URLs.host}/project`,
    getProjectUrl: (projectNumber) => `${URLs.host}/project/${projectNumber}`,
    getChecListItemUrl: (uuid) => `${URLs.host}/unit-checklist/${encodeURIComponent(uuid)}`,
    getPunchListsPerProjectUrl: (projectNumber, disciplineId?, unitChecklistId?) => {
        if (disciplineId && unitChecklistId) return `${URLs.host}/punch-list?projectNumber=${projectNumber}&disciplineId=${disciplineId}&unitChecklistId=${encodeURIComponent(unitChecklistId)}`
        if (disciplineId) return `${URLs.host}/punch-list?projectNumber=${projectNumber}&disciplineId=${disciplineId}`
        else return `${URLs.host}/punch-list?projectNumber=${projectNumber}`
    },
    postPunchListsUrl: () => `${URLs.host}/punch-list`,
    postNewProjectUrl: () => `${URLs.host}/Project`,
    archiveProjectUrl: (projectNumber) => `${URLs.host}/Project/archive/${projectNumber}`,
    unArchiveProjectUrl: (projectNumber) => `${URLs.host}/Project/unarchive/${projectNumber}`,
    putPunchListUrl: (uuid) => `${URLs.host}/punch-list/${encodeURIComponent(uuid)}`,
    deletePunchListUrl: (uuid) => `${URLs.host}/punch-list/${encodeURIComponent(uuid)}`,
    deleteUserUrl: (userUuid) => `${URLs.host}/assignment/${encodeURIComponent(userUuid)}`,
    getCommentsUrl: (projectNumber) => `${URLs.host}/comment?projectNumber=${projectNumber}`,
    // getCommentsUrl: (projectNumber, disciplineId) => `${URL.host}/comment?projectNumber=${projectNumber}&disciplineId=${disciplineId}`,
    postCommentsUrl: () => `${URLs.host}/comment`,
    putCommentsUrl: (commentUuid) => `${URLs.host}/comment/${encodeURIComponent(commentUuid)}`,
    getChangeLogsUrl: (projectNumber) => `${URLs.host}/changelog?projectNumber=${projectNumber}`,
    getChangeLogsPerDisciplineUrl: (projectNumber, disciplineId) => `${URLs.host}/changelog?projectNumber=${projectNumber}&disciplineId=${disciplineId}`,
    getUpdatedChangeLogsUrl: (projectNumber, disciplineId = null, checklistUuid = null, punchListUuid = null) => {
        let url = `${URLs.host}/changelog?projectNumber=${projectNumber}`;
        if (disciplineId !== null && disciplineId !== undefined && disciplineId !== "") {
            url += `&disciplineId=${disciplineId}`;
        }
        if (checklistUuid) {
            url += `&unitChecklistUuid=${encodeURIComponent(checklistUuid)}`;
        } else if (punchListUuid) {
            url += `&punchListUuid=${encodeURIComponent(punchListUuid)}`;
        }
        return url;
    },
    getChangelogsTypesUrl: () => `${URLs.host}/changelogType`,
    getIssuesUrl: () => `${URLs.host}/issue`,
    getStatusUrl: () => `${URLs.host}/status`,
    getCategoriesUrl: () => `${URLs.host}/category`,
    getFilesPathesUrl: (projectNumber: number) => `${URLs.host}/file/drawing/list/${projectNumber}`,
    postDrawingsUrl: () => `${URLs.host}/drawing`,
    putDrawingsUrl: (id) => `${URLs.host}/drawing/${encodeURIComponent(id)}`,
    deleteDrawingUrl: (id) => `${URLs.host}/drawing/${encodeURIComponent(id)}`,
    postDrawingsUrl2: () => `${URLs.host}/File/drawing`,
    getDrawingsUrl: (projectNumber: number) => `${URLs.host}/drawing?projectNumber=${projectNumber}`,
    getFileBlobUrl: (filePath: string) => `${URLs.host}/file/drawing/image/${encodeURIComponent(filePath)}`,
    getFileBlobUrl2: (projectNumber: number, fileName: string) => `${URLs.host}/file/drawing/${projectNumber}/${encodeURIComponent(fileName)}`,
    getFilePunchListImage: (blobPath) => `${URLs.host}/file/punchlistImage/image/${encodeURIComponent(blobPath)}`,
    postFilePunchListImage: (projectNumber, imageId, category) => `${URLs.host}/file/punchlistImage/upload/${projectNumber}/${encodeURIComponent(imageId)}/${encodeURIComponent(category)}`,
    getMPCStatusUrl: (projectNumber, sequenceNumbers: Array<string>) => {
        let sequenceNumbersStringParam = ''
        for (const element of sequenceNumbers) {
            const sequenceNumber = element;
            sequenceNumbersStringParam += `&sequenceNumbers=${encodeURIComponent(sequenceNumber)}`
        }
        return `${URLs.host}/MpcStatusList?projectNumber=${projectNumber}${sequenceNumbersStringParam}`
    },
    getRelatedChecklistDetailsUrl: (projectNumber: number) => `${URLs.host}/RelatedUnitChecklists?projectNumber=${projectNumber}`,
    getCACCUrl: (projectNumber: number, disciplineId: number) => `${URLs.host}/cacc?projectNumber=${projectNumber}&disciplineId=${disciplineId}`,
    getChecklistsCACCUrl: (projectNumber: number, disciplineId: number, caCcNumber: string) => `${URLs.host}/control-checklist?projectNumber=${projectNumber}&disciplineId=${disciplineId}&caCcNumber=${encodeURIComponent(caCcNumber)}`,
    getAllUniteChecklistsUrl: (projectNumber: number, disciplineId: number, sequenceNumber: string) => `${URLs.host}/unit-checklist?projectNumber=${projectNumber}&disciplineId=${disciplineId}&sequenceNumber=${encodeURIComponent(sequenceNumber)}`,
    postUserLogUrl: () => `${URLs.host}/UserLog`,
    postTasksUrl: () => `${URLs.host}/unit-checklist`, // Adding a new adhoc task,
    getDD: (projectNumber, disciplineId, ...DDS) => {
        let dds = ""
        for (let i = 0; i < DDS.length; i++) {
            const dd = DDS[i];
            dds += `&dd0${i + 1}=${encodeURIComponent(dd)}`
        }
        return `${URLs.host}/checklist-task?projectNumber=${projectNumber}&disciplineId=${disciplineId}${dds}`
    },
    updateDD: (taskUuid) => `${URLs.host}/checklist-task/${encodeURIComponent(taskUuid)}`,
    postDD: () => `${URLs.host}/checklist-task`,
    postDDADHOC: () => `${URLs.host}/checklist-task/ad-hoc`,
    getDropDownListing: (projectNumber, disciplineId, ...DDS) => {
        let dds = ""
        for (let i = 0; i < DDS.length; i++) {
            const dd = DDS[i];
            dds += `&dd0${i + 1}=${encodeURIComponent(dd)}`
        }
        return `${URLs.host}/checklist-task/drilldown?projectNumber=${projectNumber}&disciplineId=${disciplineId}${dds}`
    },
    getChecklistDrillDownTypes: () => `${URLs.host}/checklist-task/drilldown-type`,
    postAdhocChecklistTarget: () => `${URLs.host}/adhoc/checklist-target`,
    getAdhocChecklistTarget: (projectNumber) => `${URLs.host}/adhoc/checklist-target?projectNumber=${projectNumber}`,
    getChecklistsRelatedToPunchlists: (projectNumber) => `${URLs.host}/checklist-task/with-punchlists?projectNumber=${projectNumber}`,
}

export const imageType = 'webp';
export const lastAccessDate = 'lastAccessDate';


export const StatusArray = [
    {
        "statusId": 1,
        "statusName": "Open",
        "statusDescription": "Checklist has not been inspected."
    },
    {
        "statusId": 2,
        "statusName": "Passed",
        "statusDescription": "Checklist has been inspected and passed."
    },
    {
        "statusId": 3,
        "statusName": "Failed",
        "statusDescription": "Checklist task has a defect/issue."
    },
    {
        "statusId": 4,
        "statusName": "Ready For Re-Inspection",
        "statusDescription": "Defect is ready to be re-inspected."
    },
    {
        "statusId": 5,
        "statusName": "Not Applicable",
        "statusDescription": "Checklist is not needed."
    },
    {
        "statusId": 6,
        "statusName": "Pending",
        "statusDescription": "Punch List is pending after being created (not been worked on)."
    },
    {
        "statusId": 7,
        "statusName": "Duplicate",
        "statusDescription": "Punch List has another identical record."
    },
    {
        "statusId": 8,
        "statusName": "Completed",
        "statusDescription": "Punch List was marked complete (Passed RFR or RFR not needed)."
    },
    {
        "statusId": 9,
        "statusName": "On-Hold",
        "statusDescription": "Punch List is on hold for parts."
    },
    {
        "statusId": 10,
        "statusName": "Cancelled",
        "statusDescription": "Punch List is no longer needed or created by mistake."
    }
]

export const Status = {
    Open: 1,
    Passed: 2,
    Failed: 3,
    ReadyForReInspection: 4,
    NA: 5,
    Pending: 6,
    Duplicate: 7,
    Completed: 8,
    OnHold: 9,
    Cancelled: 10,
    MaterialsReceived: 11,
    CompletedWithRootCauseConflict: 12
}

//  this object is useful to map the statusId to the statusName , inverse of the Status object
// export const StatusObject = Object.fromEntries(Object.entries(Status).map(([key, value]) => [value, key]));

export const ActiveStatusNumber = {
    4: 'ReadyForReInspection',
    6: 'Pending',
    9: 'OnHold',
    1: 'MaterialsReceived1',
}

export const PunchListViewOptions = {
    ERM_RELEVANT: {
        name: 'ErmRelevant',
        label: 'ERM Relevant Identified Punch Lists'
    },
    MY_PUNCH_LISTS: {
        name: 'My',
        label: 'PunchList Items You Identified'
    },
    ALL_PUNCH_LISTS: {
        name: 'All',
        label: 'All Punch Lists'
    },
    DISCIPLINE: {
        name: 'Discipline',
        label: ''
    }
}

export const ERM = {
    "Scope Change": "1",
    "Schedule Change": "2",
    "Cost Change": "3"
}

export const NumberToStatus = {
    1: "Open",
    2: "Passed",
    3: "Failed",
    4: "Ready For Re-Inspection",
    5: "N/A",
    6: "Pending",
    7: "Duplicate",
    8: "Completed",
    9: "On-Hold",
    10: "Cancelled",
    11: "Materials Received"
}

export const StatusToColor = {
    0: "#7F443F",
    6: "#fdb419",
    4: "#58B2FC",
    8: "#10E33B",
    10: "#EE2C1A"
}

export const StatusToTwClass = {
    1: "",
    2: "bg-green-500 hover:bg-green-500",
    3: "bg-red-500 hover:bg-red-500",
    5: "line-through",
}

export const SapVersionOptions = [
    { text: "R/3", value: SapVersion.R3 },
    { text: "S/4HANA", value: SapVersion.S4HANA },
];

export const ChecklistStatusFilterOptions = [
    { label: 'All', value: null, activeClass: 'bg-gray-700 text-white', inactiveClass: 'bg-gray-100 text-gray-700 border border-gray-300 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600' },
    { label: 'Open', value: Status.Open, activeClass: 'bg-gray-500 text-white', inactiveClass: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200' },
    { label: 'Passed', value: Status.Passed, activeClass: 'bg-green-600 text-white', inactiveClass: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' },
    { label: 'Failed', value: Status.Failed, activeClass: 'bg-red-600 text-white', inactiveClass: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' },
    { label: 'N/A', value: Status.NA, activeClass: 'bg-gray-400 text-white line-through', inactiveClass: 'bg-gray-100 text-gray-500 line-through dark:bg-gray-800 dark:text-gray-400' },
] as const;

export const ChecklistStatusDropdownOptions: { label: string; value: number }[] = [
    { label: 'Open', value: Status.Open },
    { label: 'Passed', value: Status.Passed },
    { label: 'Failed', value: Status.Failed },
    { label: 'N/A', value: Status.NA },
];

export const ChecklistStatusDropdownConfig = {
    placeholder: 'Filter by status...',
    maxWidth: 350,
    theme: (theme: any) => ({
        ...theme,
        colors: {
            ...theme.colors,
            primary25: '#fdb419',
            primary: '#fdb419',
            neutral0: 'var(--select-background, #fff)',
            neutral80: 'var(--select-text, black)',
            neutral50: 'gray',
            neutral20: 'gray',
        },
    }),
} as const;

export const Priorities = {
    "High": 1,
    "Medium": 2,
    "Low": 3,
}

export const NumberToPriority = {
    1: "High",
    2: "Medium",
    3: "Low",
}

export const CookiesKeys = {
    jwt: "jwt",
    roles: "roles",
    username: "username",
    name: "name",
    loginPlatform: "loginPlatform",
}

export const LoginPlatforms = {
    azure: "AZURE",
    ciam: "CIAM",
}

export const photosKeys = {
    // order of these items really matters :)
    correctedPic1: "storedCorrectedPic1",
    correctedPic2: "storedCorrectedPic2",
    defectPic1: "storedDefectPic1",
    defectPic2: "storedDefectPic2",
}


// disciplineId 2,3,4,5 ==> drilldown_type_id = 1
// disciplineId 1,6,7,8 ==> drilldown_type_id = 4

export const getDrilldownType = (disciplineId: number) => {
    switch (disciplineId) {
        // case 2:
        // case 3:
        // case 4:
        // case 5:
        // case 9:
        // case 10:
        //     return 1;
        case 1:
        case 6:
        case 7:
        case 8:
            return 4;
        default:
            return 1;
    }
}

export const DrilldownMapping: DrilldownMappingItems = {
    1: {
        drilldownTypeId: "drilldownTypeId",
        dd01: "dd01",
        dd02: "dd02",
        dd03: null,
        dd04: null,
        dd05: null,
        taskDescription: "taskDescription",
        modelNumber: "modelNumber",
        modelDescription: "modelDescription",
        inspectionVersion: "inspectionVersion",
        listOrder: "listOrder",
    },
    2: {
        drilldownTypeId: "drilldownTypeId",
        dd01: "dd01",
        dd02: "dd02",
        dd03: "dd03",
        dd04: null,
        dd05: null,
        taskDescription: "taskDescription",
        modelNumber: "modelNumber",
        modelDescription: null,
        inspectionVersion: null,
        listOrder: "listOrder",
    }
}
/**
 * 
 * 1 -> dd01 -> dd02 -> taskDescription
 * 2 -> dd01 -> dd02 -> dd03 -> taskDescription
 */
export const DrilldownMappingMeaning: ChecklistTaskDropdown = {
    1: {
        drilldownTypeId: 1,
        drilldownTypeDescription: "Mechanical - Standard",
        dd01: "Sequence",
        dd02: "Unit",
        dd03: null,
        dd04: null,
        dd05: null,
        taskDescription: "Task",
        modelNumber: "Model Number",
        modelDescription: "Model Description",
        inspectionVersion: "Inspection Version",
        listOrder: "List Order",
        pathStepsToShowTasks: 2
    },
    2: {
        drilldownTypeId: 2,
        drilldownTypeDescription: "Control - Standard",
        dd01: "Area",
        dd02: "Checklist Type",
        dd03: "Location / Grouping",
        dd04: null,
        dd05: null,
        taskDescription: "Task",
        modelNumber: "Inspection Type",
        modelDescription: null,
        inspectionVersion: null,
        listOrder: "List Order",
        pathStepsToShowTasks: 3
    }
}
export const DrilldownSelectedPropsMeaning: ChecklistTaskDropdownSelectedProps = {
    1: {
        drilldownTypeDescription: "Mechanical - Standard",
        dd01: "Sequence",
        dd02: "Unit",
        taskDescription: "Task",
        modelNumber: "Model Number",
        modelDescription: "Model Description",
        inspectionVersion: "Inspection Version",
        statusId: "Status"
    },
    4: {
        drilldownTypeDescription: "Control - Standard",
        dd01: "Area",
        dd02: "Checklist Type",
        dd03: "Location / Grouping",
        taskDescription: "Task",
        modelNumber: "Inspection Type",
        statusId: "Status"
    }
}


export const maxIntegerInBackend = 2147483647
export const pathDelmiter = '|.|'  // &*

export const searchTermKey = "table_serach_term"
export const paginationLimits = [20, 40, 60, 80, 100];

export const searchTermLocalStorageKey = 'punchlist_view_search';
export const assignationFilterLocalStorageKey = 'punchlist_view_assignation';

// Drill-down list "return highlight" — remember the last-clicked row + scroll
// position so returning from a detail page highlights that row and keeps the
// list where it was.
export const checklistLastClickedKey = 'checklist_last_clicked';
export const tasksddLastClickedKey = 'tasksdd_last_clicked';
export const tasksddScrollKey = 'tasksdd_scroll_position';

// Tailwind classes for the highlighted (last-clicked) row and the orange hover.
export const selectedRowClassName = 'bg-orange-200 dark:bg-orange-1000 hover:bg-orange-200';
export const orangeRowHoverClassName = 'hover:bg-orange-1000 hover:text-white hover:cursor-pointer';

export const defaultAp01ToAp15Values = {
    "ap01": "",
    "ap02": "",
    "ap03": "",
    "ap04": "",
    "ap05": "",
    "ap06": "",
    "ap07": "",
    "ap08": "",
    "ap09": "",
    "ap10": "",
    "ap11": "",
    "ap12": "",
    "ap13": "",
    "ap14": "",
    "ap15": "",
}